<template>
    <div class="slider-wrapper">
        <div class="slider">
            <div class="slider--line" :style="{ width: selectedMile + '%' }"></div>
            <div
                v-for="(mile, index) in miles"
                :key="mile"
                class="slider--break"
                :class="{ 'slider--break--active': selectedMile >= mile, 'slider--break--selected': selectedMile == mile }"
                :style="{ left: calculateLeftPosition(mile) }"
                @click="selectMile(mile)"
            >
                <p class="slider--break__value" :class="{ 'slider--break__value--last': index === miles.length - 1 }">
                    {{ mile }}
                    <span v-if="index === 0 || (index === miles.length - 1 && !isTablet)">{{ $t('common.maps.miles') }}</span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'

    export default {
        mixins: [ScreenSizeDetectionMixin],
        props: {
            miles: { type: Array, default: () => [1, 20, 40, 60, 80, 100] },
            selectedMilePrefill: { type: Number, default: 20 },
        },

        data() {
            return {
                selectedMile: 0,
            }
        },
        methods: {
            selectMile(mile) {
                this.selectedMile = mile
                this.emitEvent({ name: 'distance-changed', payload: this.selectedMile })
            },
            getBreakPosition(mile) {
                return (mile - 10) * 10
            },

            calculateLeftPosition(mile) {
                this.miles[this.miles.length - 1]
                const left = (mile * 100) / this.miles[this.miles.length - 1]
                return `${left}%`
            },
        },

        mounted() {
            this.selectMile(this.selectedMilePrefill)
        },
    }
</script>

<style lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';

    .slider-wrapper {
        @include breakpoint(tablet) {
            padding: 0 10px;
        }
        padding: 0 70px;
        max-width: 800px;
        margin: 0 auto;
    }
    .slider {
        position: relative;
        height: 8px;
        background-color: $color-bg-menubar-3;
        margin-bottom: 10px;

        &--line {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 0;
            height: 8px;
            background-color: $color--accent-1;
            transition: width 0.3s ease;
        }

        &--break {
            position: absolute;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: $color-bg-menubar-3;
            cursor: pointer;
            transition: background-color 0.3s ease;

            &__value {
                position: absolute;
                bottom: -25px;
                left: 2px;
                width: 150px;
                font-size: 12px;

                &--last {
                    &:last-child {
                        left: -40px;
                    }
                }
            }

            &::before {
                content: '';
                position: absolute;
                display: inline-block;
                width: 10px;
                height: 10px;
                top: 5px;
                right: 5px;
                -moz-border-radius: 7.5px;
                -webkit-border-radius: 7.5px;
                border-radius: 7.5px;
                background-color: $color-white;
            }

            &--active {
                background-color: $color--accent-1;
                width: 20px;
                height: 20px;
            }

            &--selected {
                width: 25px;
                height: 25px;
                &::before {
                    content: '';
                    position: absolute;
                    display: inline-block;
                    width: 10px;
                    height: 10px;
                    top: 5px;
                    right: 5px;
                    -moz-border-radius: 7.5px;
                    -webkit-border-radius: 7.5px;
                    border-radius: 7.5px;
                    background-color: $color--accent-1;
                }
            }
        }
    }
</style>
